module.exports = __webpack_public_path__ + "media/images/badge-delivery-active-294652733651ad7287358f73e2a41c1e.svg";